import { useMonitorEngineContext } from '@nibfe/mcp-monitor-sdk';
import { useRequest } from './useRequest';
import { API_PATH, ACTIVITY_BLOKCED_CODE } from '../types/shared';
import { getRequestBaseParams } from '../utils/request';
const CITY_EXPLORE_MARKETING_SCENE = 1;
export function useJoinActivityAction(options) {
    const ctx = useMonitorEngineContext();
    const commonParams = ctx._runtimeInfo?.commonParams ?? {};
    const { activityId } = options ?? {};
    const { request: joinActivity } = useRequest(API_PATH.JOIN_ACTIVITY, {
        method: 'POST',
        showLoading: true
    });
    async function onTriggerJoinActivity(cardGroupKey) {
        try {
            const feCommonParams = await getRequestBaseParams(commonParams);
            const params = {
                activityId,
                ...feCommonParams,
                extra: {
                    marketingScene: CITY_EXPLORE_MARKETING_SCENE,
                    cardObtainParam: {
                        cardGroupKey: String(cardGroupKey)
                    }
                }
            };
            const res = await joinActivity(params);
            return true;
        }
        catch (error) {
            if (error?.message?.includes(ACTIVITY_BLOKCED_CODE.toString())) {
                ctx._uiInteractionAPI.toast.show({
                    content: '抱歉，当前无法参与活动'
                });
            }
            else {
                ctx._uiInteractionAPI.toast.show({
                    content: '参与活动失败，请稍后重试'
                });
            }
            ctx._raptorReport.monitorReportBizFailed?.({
                apiPath: API_PATH.JOIN_ACTIVITY
            });
            ctx._raptorReport.monitorReportLog?.('joinActivity', error, {
                level: 'error',
                category: 'ajaxError'
            });
            return false;
        }
    }
    return {
        onTriggerJoinActivity
    };
}
